/**
 * 
 * Fetch and map data as JSON object from Google spreadsheet.
 * Spreadsheet (publicly shared)
 * https://docs.google.com/spreadsheets/d/1R23v8DD80lr1hOpWjb0lkck0R3qfxP-21GZ5udhSCLQ/edit#gid=0
 * 
 * Loading spreadsheet as JSON
 * https://spreadsheets.google.com/feeds/cells/1R23v8DD80lr1hOpWjb0lkck0R3qfxP-21GZ5udhSCLQ/1/public/full?alt=json
 * 
 */

function mapData(data) {
  // console.log(data);
  const entries = data.feed.entry.reduce((acc, entry) => {
    // console.log(element.gs$cell);
    // gs$cell = { $t: "6", col: "8", inputValue: "6", numericValue: "6.0", row: "40"}
    const r = Number(entry.gs$cell.row) - 1;
    const c = Number(entry.gs$cell.col) - 1;
    if (acc[r] === undefined) acc[r] = [];
    acc[r][c] = entry.content.$t;// entry.gs$cell.numericValue ? entry.gs$cell.numericValue : entry.gs$cell.inputValue;
    return acc;
  }, []);
  // console.log(entries);
  // eslint-disable-next-line
  // const header = entries.shift();
  // console.log(header);
  const subheader = entries.shift();
  const keys = subheader.map(e => {
    return e.replace(/\s/g, '').toLowerCase();
  });

  const cardEntries = entries.map((row, rowIdx) => {
    const editors = ['Tanu', 'Pradosh', 'Satya', 'Amar'];

    const e= row.reduce((acc, c, idx) => {
      acc[keys[idx]] = c;
      return acc;
    }, { id: rowIdx })

    const ratingsBy = editors.filter(p => e.hasOwnProperty(p.toLowerCase())).join(', ');
    e.ratingsBy = ratingsBy;
    return e;
  })
    .filter(entry => entry.title !== undefined);
  cardEntries.sort((a, b) => {
    return Number(b.averagerating) - Number(a.averagerating);
    // return Number(a.year) - Number(b.year);
  });
  // console.log(cardEntries);
  return cardEntries;
}

async function loadData() {
  // const spreadSheetId = '1R23v8DD80lr1hOpWjb0lkck0R3qfxP-21GZ5udhSCLQ';
  // const uri = `https://spreadsheets.google.com/feeds/cells/${spreadSheetId}/1/public/full?alt=json`;
  // const uri = './data/full.json';
  const uri = process.env.REACT_APP_DATA_URI;
  // console.log('loadData', uri);
  let entries = [];
  let updated = 'n/a';
  try {
    const res = await fetch(uri, {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    const data = await res.json();
    // console.log(data);
    // const formatter = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' });
    updated = formatter.format(new Date(data.feed.updated.$t));
    entries = mapData(data);
  } catch (err) {
    console.error(err);
  }
  return { updated, entries };
}

export { loadData };